interface TypingSocket {
  connected?: boolean;
  emit: (event: string, data: { roomId: number }) => unknown;
}

/** Outgoing typing state, independent of message submission/evaluation latency. */
export function createTypingNotifier(socket: TypingSocket | null, roomId: number) {
  let active = false;
  let lastHeartbeat = 0;
  let idleTimer: ReturnType<typeof setTimeout> | undefined;
  const stop = () => {
    clearTimeout(idleTimer);
    idleTimer = undefined;
    if (active && socket?.connected !== false) socket?.emit('typing_stop', { roomId });
    active = false;
  };
  const update = (text: string) => {
    if (!text.trim() || !socket || socket.connected === false || !Number.isInteger(roomId) || roomId <= 0) {
      stop();
      return;
    }
    const now = Date.now();
    if (!active || now - lastHeartbeat >= 1000) {
      socket.emit('typing_start', { roomId });
      lastHeartbeat = now;
    }
    active = true;
    clearTimeout(idleTimer);
    idleTimer = setTimeout(stop, 1500);
  };
  return { update, stop };
}
